"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var material_1 = require("@mui/material");

var icons_material_1 = require("@mui/icons-material");

var prop_types_1 = __importDefault(require("prop-types"));

var InputPassword = function (props) {
  // Password state management --->
  var _a = (0, react_1.useState)(false),
      showPassword = _a[0],
      setShowPassword = _a[1];

  var handleClickShowPassword = function () {
    setShowPassword(!showPassword);
  };

  var showPasswordIcon = {
    endAdornment: react_1["default"].createElement(material_1.InputAdornment, {
      position: "end"
    }, react_1["default"].createElement(material_1.IconButton, {
      onClick: handleClickShowPassword
    }, showPassword === true ? react_1["default"].createElement(icons_material_1.Visibility, null) : react_1["default"].createElement(icons_material_1.VisibilityOff, null)))
  }; // Props por defecto --->

  var defaultProps = __assign({
    inputProps: {
      type: showPassword ? "text" : "password"
    },
    InputProps: showPasswordIcon
  }, props);

  return react_1["default"].createElement(material_1.TextField, __assign({}, defaultProps));
};

InputPassword.propTypes = {
  onChange: prop_types_1["default"].func.isRequired,
  value: prop_types_1["default"].any.isRequired
};
exports["default"] = InputPassword;